import { fyaiCharacters } from "@/mocks/fyai-data";

export default function FyaiCharacters() {
  return (
    <section id="characters" className="w-full bg-background-100 px-4 py-16 md:px-6 md:py-24">
      <div className="mb-12 flex flex-col items-start justify-between gap-4 lg:flex-row lg:items-end">
        <div className="max-w-2xl">
          <span className="inline-flex items-center gap-2 rounded-full bg-primary-100 px-3 py-1.5 text-xs font-medium text-primary-700">
            <i className="ri-group-2-line" />
            AI角色
          </span>
          <h2 className="mt-4 font-heading text-3xl font-bold text-foreground-950 md:text-4xl">
            在这里遇见你的TA
          </h2>
          <p className="mt-4 text-sm leading-relaxed text-foreground-600 md:text-base">
            校园的甜美学妹、古风温柔的花魁、占有欲满满的都市霸总……风月AI的角色各有性格，等你开启第一句话。
          </p>
        </div>
        <p className="text-sm text-foreground-500">共 120+ 位可攻略角色</p>
      </div>

      <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
        {fyaiCharacters.map((char) => (
          <article
            key={char.name}
            className="group overflow-hidden rounded-card border border-background-200 bg-background-50"
          >
            <div className="relative aspect-[4/5] w-full overflow-hidden">
              <img
                src={char.image}
                alt={`风月AI角色${char.name}`}
                title={`风月AI聊天软件角色${char.name}`}
                className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-[1.04]"
              />
              <span className="absolute left-3 top-3 inline-flex items-center gap-1 rounded-full bg-primary-950/70 px-2.5 py-1 text-[11px] font-medium text-accent-300">
                <i className="ri-fire-fill" />
                {char.heat}
              </span>
            </div>
            <div className="p-4 md:p-5">
              <div className="flex items-center gap-2">
                <h3 className="truncate font-heading text-base font-bold text-foreground-950">{char.name}</h3>
                <i
                  className={
                    char.gender === "男"
                      ? "ri-men-line text-secondary-500"
                      : "ri-women-line text-primary-500"
                  }
                />
              </div>
              <p className="mt-2 line-clamp-2 min-h-[2.6rem] text-xs leading-relaxed text-foreground-600 md:text-sm">
                “{char.quote}”
              </p>
              <div className="mt-3 flex flex-wrap gap-1.5">
                {char.tags.map((tag) => (
                  <span
                    key={tag}
                    className="rounded-full bg-secondary-100 px-2.5 py-1 text-[11px] font-medium text-secondary-900"
                  >
                    {tag}
                  </span>
                ))}
              </div>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}